export const content = {
  en: {
    // Header
    brandName: 'BRILLIANT TOUCH',
    brandTagline: 'Professional Cleaning',
    nav: {
      services: 'Services',
      results: 'Results',
      areas: 'Areas',
      contact: 'Contact',
      whatsapp: 'WhatsApp'
    },

    // Hero
    hero: {
      chip: '✨ Transform Your Space Into a Spotless Paradise',
      title: 'Experience The Magic of Professional Cleaning That Makes Your Property Shine Like Never Before!',
      description: 'Say goodbye to stress and hello to sparkling clean spaces! We deliver exceptional cleaning results that exceed expectations. Your satisfaction is 100% guaranteed, or we come back FREE. Join hundreds of delighted clients who trust us with their most valuable spaces.',
      cta1: 'Get Instant Quote Now',
      cta2: 'Call Us Today',
      cta3: 'Book FREE Consultation',
      badges: [
        '🌟 5-Star Rated Service',
        '⚡ 24/7 Emergency Service',
        '💯 Satisfaction Guaranteed'
      ],
      stats: [
        { label: '24/7', sublabel: 'Available' },
        { label: 'Eco', sublabel: 'Friendly' },
        { label: 'Trusted', sublabel: 'Experts' }
      ]
    },

    // Services
    services: {
      title: 'Premium Cleaning Solutions That Transform Every Space',
      subtitle: 'From routine maintenance to deep transformations - we make your property look and feel brand new. Experience cleaning that goes beyond expectations!',
      items: [
        {
          icon: 'home',
          title: 'Luxury Home Cleaning',
          description: 'Transform your home into a pristine sanctuary. We deep clean every corner, leaving your space fresh, healthy, and absolutely stunning. Your family deserves the best!'
        },
        {
          icon: 'building',
          title: 'Executive Office Solutions',
          description: 'Impress clients and boost productivity with immaculate workspaces. Professional cleaning that reflects your business excellence. First impressions matter!'
        },
        {
          icon: 'store',
          title: 'Retail & Commercial Magic',
          description: 'Attract more customers with a spotless, inviting environment. We make your business shine and stand out from the competition. Clean stores sell more!'
        },
        {
          icon: 'hard-hat',
          title: 'Post-Construction Perfection',
          description: 'From dust-covered chaos to move-in ready perfection! We handle the toughest jobs with precision. Ready to wow your clients? We have got you covered!'
        },
        {
          icon: 'package',
          title: 'Move-In/Out Excellence',
          description: 'Get your deposit back or welcome new tenants with confidence! Deep, thorough cleaning that makes properties look brand new. Fast turnaround guaranteed!'
        },
        {
          icon: 'calendar',
          title: 'VIP Maintenance Plans',
          description: 'Never worry about cleaning again! Flexible weekly, bi-weekly, or monthly service. Consistent excellence, exclusive priority booking, special member rates!'
        }
      ]
    },

    // Why Section
    why: {
      title: 'Why Smart Property Owners Choose Us Every Time',
      items: [
        '🚀 Instant Response - We answer in minutes, not hours. Your time is valuable!',
        '💎 Premium Results - Professional-grade cleaning that makes spaces look magazine-ready',
        '🛡️ 100% Satisfaction Guarantee - Love it or we clean it again FREE, no questions asked',
        '⭐ 500+ Five-Star Reviews - Join hundreds of thrilled customers who rave about us',
        '🌿 Eco-Friendly Products - Safe for kids, pets, and the planet. Health comes first!'
      ]
    },

    // Before/After
    results: {
      title: 'Jaw-Dropping Transformations That Speak for Themselves',
      subtitle: 'See the incredible difference professional cleaning makes! These amazing before & after results are what you can expect every single time.',
      comparisons: [
        {
          title: 'Kitchen Deep Clean Transformation',
          label: 'Before',
          before: ['Cluttered countertops', 'Dirty appliances', 'Grease buildup'],
          after: ['Spotless surfaces!', 'Sparkling appliances', 'Fresh & organized']
        },
        {
          title: 'Living Space Revival',
          label: 'After',
          before: ['Messy & cluttered', 'Dust everywhere', 'Disorganized chaos'],
          after: ['Pristine & organized!', 'Fresh atmosphere', 'Magazine-ready clean']
        }
      ]
    },

    // Areas
    areas: {
      title: 'Proudly Serving All of Connecticut - We Come to You!',
      description: 'Local, trusted, and always on time! Experience the convenience of having Connecticut\'s #1 rated cleaning service just a phone call away. Flexible scheduling to fit your needs!',
      cities: ['Waterbury', 'Hartford', 'New Haven', 'Meriden', 'Bridgeport', 'Danbury'],
      whyTitle: 'Why Local Clients Book Us Within Minutes',
      whyItems: [
        '⚡ Lightning-Fast Response - We are in your neighborhood and ready to help NOW!',
        '🎯 Crystal-Clear Pricing - No hidden fees, no surprises. Just honest, fair rates',
        '📱 Easy Booking - One click, one call, one message. It is that simple!',
        '🏆 Proven Track Record - 5+ years making Connecticut properties sparkle and shine'
      ]
    },

    // Social
    social: {
      title: 'Join Our Community of Happy Customers!',
      subtitle: 'Follow us for cleaning tips, exclusive offers, before & after reveals, and special promotions. Don\'t miss out on member-only deals!',
      platforms: [
        { name: 'Facebook', icon: 'facebook', label: 'Follow Us' },
        { name: 'Instagram', icon: 'instagram', label: 'See Results' },
        { name: 'TikTok', icon: 'music', label: 'Watch Videos' },
        { name: 'WhatsApp', icon: 'message-circle', label: 'Chat Now' }
      ]
    },

    // Reviews
    reviews: {
      title: 'Real Stories from Real Customers Who Love Us!',
      subtitle: 'Don\'t just take our word for it - hear what your neighbors are saying about their amazing experiences!',
      items: [
        {
          stars: 5,
          text: '"INCREDIBLE! My house has never looked this good. They cleaned places I didn\'t even know existed! Worth every penny and more. Highly recommend!"',
          author: '— Sarah M., Homeowner'
        },
        {
          stars: 5,
          text: '"Best decision ever! Fast, reliable, and the results are outstanding. Our tenants are amazed every time. These guys are the REAL DEAL!"',
          author: '— Michael R., Property Manager'
        },
        {
          stars: 5,
          text: '"WOW! Transformed our construction site into a showroom. Clients were blown away. Will use them for every project. Simply the best!"',
          author: '— James T., Contractor'
        }
      ]
    },

    // CTA
    cta: {
      title: 'Ready for a Spotless Space? Let\'s Make It Happen TODAY!',
      description: 'Don\'t wait another day living with dirt and clutter. Get your FREE quote now and discover why thousands trust us. Book your appointment today!',
      btn1: 'Get Instant Quote',
      btn2: 'Call Now'
    },

    // Contact
    contact: {
      title: 'Get Your FREE Quote in Under 60 Seconds!',
      phone: '475-343-7298',
      whatsapp: 'Chat Instantly',
      email: 'groupbrillianttouch@gmail.com',
      area: 'All Connecticut',
      scheduleLabel: 'Flexible Scheduling',
      scheduleText: 'Next-Day • Weekly • Bi-Weekly • Monthly - You Choose!',
      tip: '💡 Pro Tip: Book now and get 10% off your first cleaning service!',
      formTitle: 'Claim Your FREE Quote Now!',
      formPlaceholders: {
        name: 'Your Full Name',
        phone: 'Best Phone Number',
        email: 'Your Email Address',
        service: 'What Service Do You Need?',
        message: 'Tell us about your space and when you\'d like us to work our magic! (Be specific for the best quote)'
      },
      formSubmit: 'Get My FREE Quote',
      formNote: '🔒 Your information is 100% secure. We respect your privacy and never share your details. Instant response guaranteed!',
      serviceOptions: [
        '🏠 Luxury Home Cleaning',
        '🏢 Executive Office Cleaning',
        '🏪 Retail Store Cleaning',
        '🛠️ Post-Construction Cleanup',
        '📦 Move-In / Move-Out Service',
        '⭐ VIP Recurring Service'
      ]
    },

    // Footer
    footer: {
      tagline: 'Making Connecticut Shine, One Space at a Time! ✨'
    }
  },
  es: {
    // Header
    brandName: 'BRILLIANT TOUCH',
    brandTagline: 'Professional Cleaning',
    nav: {
      services: 'Servicios',
      results: 'Resultados',
      areas: 'Áreas',
      contact: 'Contacto',
      whatsapp: 'WhatsApp'
    },

    // Hero
    hero: {
      chip: '✨ Transforma Tu Espacio en un Paraíso Impecable',
      title: '¡Experimenta la Magia de la Limpieza Profesional Que Hace Brillar Tu Propiedad Como Nunca Antes!',
      description: '¡Di adiós al estrés y hola a espacios relucientes! Entregamos resultados excepcionales que superan todas las expectativas. Tu satisfacción está 100% garantizada, o regresamos GRATIS. Únete a cientos de clientes encantados que confían en nosotros con sus espacios más valiosos.',
      cta1: 'Cotización Instantánea',
      cta2: 'Llama Hoy Mismo',
      cta3: 'Consulta GRATIS',
      badges: [
        '🌟 Servicio 5 Estrellas',
        '⚡ Servicio de Emergencia 24/7',
        '💯 Garantía Total'
      ],
      stats: [
        { label: '24/7', sublabel: 'Disponible' },
        { label: 'Eco', sublabel: 'Amigable' },
        { label: 'Expertos', sublabel: 'Confiables' }
      ]
    },

    // Services
    services: {
      title: 'Soluciones Premium Que Transforman Cada Espacio',
      subtitle: '¡Desde mantenimiento rutinario hasta transformaciones profundas - hacemos que tu propiedad luzca y se sienta como nueva! ¡Limpieza que supera expectativas!',
      items: [
        {
          icon: 'home',
          title: 'Limpieza de Lujo para Hogares',
          description: '¡Transforma tu hogar en un santuario prístino! Limpiamos cada rincón profundamente, dejando tu espacio fresco, saludable y absolutamente impresionante. ¡Tu familia merece lo mejor!'
        },
        {
          icon: 'building',
          title: 'Soluciones Ejecutivas',
          description: '¡Impresiona a clientes y aumenta la productividad con espacios impecables! Limpieza profesional que refleja la excelencia de tu negocio. ¡La primera impresión cuenta!'
        },
        {
          icon: 'store',
          title: 'Magia Comercial y Retail',
          description: '¡Atrae más clientes con un ambiente impecable y acogedor! Hacemos brillar tu negocio y destacar de la competencia. ¡Las tiendas limpias venden más!'
        },
        {
          icon: 'hard-hat',
          title: 'Perfección Post-Construcción',
          description: '¡De caos lleno de polvo a perfección lista para entregar! Manejamos los trabajos más difíciles con precisión. ¿Listo para impresionar? ¡Te respaldamos!'
        },
        {
          icon: 'package',
          title: 'Excelencia en Mudanzas',
          description: '¡Recupera tu depósito o recibe inquilinos con confianza! Limpieza profunda que hace que las propiedades luzcan como nuevas. ¡Respuesta rápida garantizada!'
        },
        {
          icon: 'calendar',
          title: 'Planes VIP de Mantenimiento',
          description: '¡Nunca te preocupes por limpiar otra vez! Servicio flexible semanal, quincenal o mensual. ¡Excelencia constante, reservas prioritarias, tarifas especiales!'
        }
      ]
    },

    // Why Section
    why: {
      title: 'Por Qué Los Dueños Inteligentes Nos Eligen Siempre',
      items: [
        '🚀 Respuesta Instantánea - Contestamos en minutos, no en horas. ¡Tu tiempo es valioso!',
        '💎 Resultados Premium - Limpieza de nivel profesional que hace lucir espacios dignos de revista',
        '🛡️ 100% Garantía de Satisfacción - Te encanta o lo limpiamos de nuevo GRATIS, sin preguntas',
        '⭐ 500+ Reseñas de 5 Estrellas - Únete a cientos de clientes encantados que nos recomiendan',
        '🌿 Productos Eco-Amigables - Seguros para niños, mascotas y el planeta. ¡La salud es primero!'
      ]
    },

    // Before/After
    results: {
      title: '¡Transformaciones Increíbles Que Hablan Por Sí Mismas!',
      subtitle: '¡Mira la diferencia increíble que hace la limpieza profesional! Estos resultados asombrosos son lo que puedes esperar cada vez.',
      comparisons: [
        {
          title: 'Transformación Profunda de Cocina',
          label: 'Before',
          before: ['Mostradores desordenados', 'Electrodomésticos sucios', 'Acumulación de grasa'],
          after: ['¡Superficies impecables!', 'Electrodomésticos relucientes', 'Fresca y organizada']
        },
        {
          title: 'Renovación de Espacio Vital',
          label: 'After',
          before: ['Desordenado y caótico', 'Polvo por todas partes', 'Caos desorganizado'],
          after: ['¡Prístino y organizado!', 'Ambiente fresco', 'Limpieza digna de revista']
        }
      ]
    },

    // Areas
    areas: {
      title: '¡Sirviendo Todo Connecticut - Vamos Hasta Ti!',
      description: '¡Local, confiable y siempre puntual! Experimenta la conveniencia de tener el servicio de limpieza #1 de Connecticut a solo una llamada. ¡Horarios flexibles que se ajustan a ti!',
      cities: ['Waterbury', 'Hartford', 'New Haven', 'Meriden', 'Bridgeport', 'Danbury'],
      whyTitle: 'Por Qué Clientes Locales Nos Reservan en Minutos',
      whyItems: [
        '⚡ Respuesta Ultrarrápida - ¡Estamos en tu vecindario y listos para ayudar AHORA!',
        '🎯 Precios Cristalinos - Sin cargos ocultos, sin sorpresas. Solo tarifas honestas y justas',
        '📱 Reserva Fácil - Un clic, una llamada, un mensaje. ¡Así de simple!',
        '🏆 Historial Comprobado - 5+ años haciendo brillar propiedades en Connecticut'
      ]
    },

    // Social
    social: {
      title: '¡Únete a Nuestra Comunidad de Clientes Felices!',
      subtitle: 'Síguenos para tips de limpieza, ofertas exclusivas, transformaciones increíbles y promociones especiales. ¡No te pierdas ofertas solo para miembros!',
      platforms: [
        { name: 'Facebook', icon: 'facebook', label: 'Síguenos' },
        { name: 'Instagram', icon: 'instagram', label: 'Ver Resultados' },
        { name: 'TikTok', icon: 'music', label: 'Ver Videos' },
        { name: 'WhatsApp', icon: 'message-circle', label: 'Chatear Ya' }
      ]
    },

    // Reviews
    reviews: {
      title: '¡Historias Reales de Clientes Que Nos Aman!',
      subtitle: '¡No solo creas en nuestra palabra - escucha lo que tus vecinos dicen sobre sus experiencias increíbles!',
      items: [
        {
          stars: 5,
          text: '"¡INCREÍBLE! Mi casa nunca se ha visto tan bien. ¡Limpiaron lugares que ni sabía que existían! Vale cada centavo y más. ¡Altamente recomendados!"',
          author: '— Sarah M., Propietaria'
        },
        {
          stars: 5,
          text: '"¡La mejor decisión! Rápidos, confiables y los resultados son sobresalientes. Nuestros inquilinos quedan asombrados cada vez. ¡Son los VERDADEROS EXPERTOS!"',
          author: '— Michael R., Administrador'
        },
        {
          stars: 5,
          text: '"¡WOW! Transformaron nuestro sitio de construcción en una sala de exhibición. Los clientes quedaron impresionados. Los usaré en cada proyecto. ¡Simplemente los mejores!"',
          author: '— James T., Contratista'
        }
      ]
    },

    // CTA
    cta: {
      title: '¿Listo Para Un Espacio Impecable? ¡Hagámoslo Realidad HOY!',
      description: '¡No esperes otro día viviendo con suciedad y desorden! Obtén tu cotización GRATIS ahora y descubre por qué miles confían en nosotros. ¡Reserva tu cita hoy!',
      btn1: 'Cotización Instantánea',
      btn2: 'Llamar Ahora'
    },

    // Contact
    contact: {
      title: '¡Tu Cotización GRATIS en Menos de 60 Segundos!',
      phone: '475-343-7298',
      whatsapp: 'Chat Instantáneo',
      email: 'groupbrillianttouch@gmail.com',
      area: 'Todo Connecticut',
      scheduleLabel: 'Horarios Flexibles',
      scheduleText: 'Próximo Día • Semanal • Quincenal • Mensual - ¡Tú Eliges!',
      tip: '💡 Consejo Pro: ¡Reserva ahora y obtén 10% de descuento en tu primer servicio!',
      formTitle: '¡Reclama Tu Cotización GRATIS Ahora!',
      formPlaceholders: {
        name: 'Tu Nombre Completo',
        phone: 'Mejor Número de Teléfono',
        email: 'Tu Dirección de Email',
        service: '¿Qué Servicio Necesitas?',
        message: '¡Cuéntanos sobre tu espacio y cuándo quieres que hagamos nuestra magia! (Sé específico para la mejor cotización)'
      },
      formSubmit: 'Obtener Mi Cotización GRATIS',
      formNote: '🔒 Tu información está 100% segura. Respetamos tu privacidad y nunca compartimos tus datos. ¡Respuesta instantánea garantizada!',
      serviceOptions: [
        '🏠 Limpieza de Lujo para Hogares',
        '🏢 Limpieza Ejecutiva de Oficinas',
        '🏪 Limpieza de Tiendas Retail',
        '🛠️ Limpieza Post-Construcción',
        '📦 Servicio de Mudanzas',
        '⭐ Servicio VIP Recurrente'
      ]
    },

    // Footer
    footer: {
      tagline: '¡Haciendo Brillar Connecticut, Un Espacio a la Vez! ✨'
    }
  }
};

export const contactInfo = {
  phone: '+14753437298',
  phoneDisplay: '475-343-7298',
  email: 'groupbrillianttouch@gmail.com',
  whatsappUrl: 'https://wa.me/14753437298?text=Hi%20Brilliant%20Touch%2C%20I%20want%20a%20free%20quote',
  googleReviewsUrl: 'https://share.google/4twB5KhV2uvApcjAQ',
  socialLinks: {
    facebook: 'https://www.facebook.com/share/1bnLQzovdo/?mibextid=wwXIfr',
    instagram: 'https://www.instagram.com/brillianttouch_ct?igsh=ZWFhZzBsa3l4bXpo&utm_source=qr',
    tiktok: 'https://www.tiktok.com/@brilliant.touch6?_r=1&_t=ZT-96dq1lmvqm5'
  }
};
